
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexxkOWU5vtvFt87a0IUCSNElaTUM1dr88uiD15T3Vf28EMeta } from "/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/index.vue?macro=true";
import { default as seatsJZZks62z4pEMVczVH5oInACPBHIJ2nd4_LEtocX2t7oMeta } from "/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/seats.vue?macro=true";
import { default as ticketsRpwfa37H_19KQOU8Rxs5j9YjaYPcuNHB490AmypXWokMeta } from "/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/tickets.vue?macro=true";
import { default as _64_91username_934kSUGF56QKpVoV0sJ6VdWrULGrGxMJH53PhnDSk0WKQMeta } from "/home/runner/work/web/web/pages/@[username].vue?macro=true";
import { default as aboutpigS8gLOS3OvF64gIokEO_45BzgXkr_45yioiC0UITSN5IoMeta } from "/home/runner/work/web/web/pages/about.vue?macro=true";
import { default as _91username_93qDKid1aHOzUFyiDQB3_45a6UtMsSb8quEmaW97S7_45MzbAMeta } from "/home/runner/work/web/web/pages/artist/[username].vue?macro=true";
import { default as artists7CfwogbQq_45XaRnSVGQ83XSY0nDLSAo7GmbyPsf1nAuMMeta } from "/home/runner/work/web/web/pages/artists.vue?macro=true";
import { default as cancel_45policyRrke4UHu1PEAmL_vfpyJmNDaIp_OXYQ_8VcCNliV85cMeta } from "/home/runner/work/web/web/pages/cancel-policy.vue?macro=true";
import { default as cookie_45policyQ8SkLOcfJjJY0F1efL2JYl1WznhQIzE4GDNLr83Lm3gMeta } from "/home/runner/work/web/web/pages/cookie-policy.vue?macro=true";
import { default as delete_45accountozTArS7HW_6WrFLFT2LSaoKPqdoOSV_dCDQpmcL204MMeta } from "/home/runner/work/web/web/pages/delete-account.vue?macro=true";
import { default as _91hash_93ddaNlYVdhcOLYJoXo7ZxhD3CB8mUcpn4Us5TI_45iFvxIMeta } from "/home/runner/work/web/web/pages/get-tickets/[hash].vue?macro=true";
import { default as helpxwVay8MEhKU6Vz1sVFirmI1o9GT23ZVuCJ2KIozsEAoMeta } from "/home/runner/work/web/web/pages/help.vue?macro=true";
import { default as index1lVG_o0JqBYA3uY09iAI_QNWKEvAirFX339k_Ls9Q_45AMeta } from "/home/runner/work/web/web/pages/index.vue?macro=true";
import { default as callbackzKJEp9N3KrbL8ekTtafm_45I_45teW_f46fK5IPTc4dEmpgMeta } from "/home/runner/work/web/web/pages/payment-method/[method]/callback.vue?macro=true";
import { default as platformUkaOD5CJkpHeJv367cCOjTUVxTJ_PGtNoSpAsguvS3YMeta } from "/home/runner/work/web/web/pages/platform.vue?macro=true";
import { default as privacy_45policy_7rhbN_uxE3aF5EevBZ7sgGXdp0YOvWV93VSpd24xiIMeta } from "/home/runner/work/web/web/pages/privacy-policy.vue?macro=true";
import { default as _91username_93C_451Z2V5JKaVUblj_n2tEH8KRg2p_45xhKJpD7Oq3y2Bo8Meta } from "/home/runner/work/web/web/pages/producer/[username].vue?macro=true";
import { default as producersLvXUS9qTPIcsJM2eW_JFk_45L7kRyeQi32T6d_fFaEIfQMeta } from "/home/runner/work/web/web/pages/producers.vue?macro=true";
import { default as sellspJXRtyBc8Lz8XmjcpeBqG6A3q7DpaPHQCbHFOuLEIgMeta } from "/home/runner/work/web/web/pages/sell.vue?macro=true";
import { default as terms_45and_45conditionswsPqjgtoCx8PlbhBBUt9lXw_45pJjzQXrrxFso_45btronoMeta } from "/home/runner/work/web/web/pages/terms-and-conditions.vue?macro=true";
import { default as use_45conditions_45AJnN3o4et6CZncfFiemOwBdDEN95ERM4OvwB7uaDN0Meta } from "/home/runner/work/web/web/pages/use-conditions.vue?macro=true";
export default [
  {
    name: "type-tickets-dateId___pa___default",
    path: "/:type()-tickets/:dateId?",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId___pa",
    path: "/pa/:type()-tickets/:dateId?",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId___ve",
    path: "/ve/:type()-tickets/:dateId?",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId___co",
    path: "/co/:type()-tickets/:dateId?",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/index.vue")
  },
  {
    name: "type-tickets-dateId-seats___pa___default",
    path: "/:type()-tickets/:dateId?/seats",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-seats___pa",
    path: "/pa/:type()-tickets/:dateId?/seats",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-seats___ve",
    path: "/ve/:type()-tickets/:dateId?/seats",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-seats___co",
    path: "/co/:type()-tickets/:dateId?/seats",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/seats.vue")
  },
  {
    name: "type-tickets-dateId-tickets___pa___default",
    path: "/:type()-tickets/:dateId?/tickets",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "type-tickets-dateId-tickets___pa",
    path: "/pa/:type()-tickets/:dateId?/tickets",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "type-tickets-dateId-tickets___ve",
    path: "/ve/:type()-tickets/:dateId?/tickets",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "type-tickets-dateId-tickets___co",
    path: "/co/:type()-tickets/:dateId?/tickets",
    component: () => import("/home/runner/work/web/web/pages/[type]-tickets/[[dateId]]/tickets.vue")
  },
  {
    name: "@username___pa___default",
    path: "/@:username()",
    component: () => import("/home/runner/work/web/web/pages/@[username].vue")
  },
  {
    name: "@username___pa",
    path: "/pa/@:username()",
    component: () => import("/home/runner/work/web/web/pages/@[username].vue")
  },
  {
    name: "@username___ve",
    path: "/ve/@:username()",
    component: () => import("/home/runner/work/web/web/pages/@[username].vue")
  },
  {
    name: "@username___co",
    path: "/co/@:username()",
    component: () => import("/home/runner/work/web/web/pages/@[username].vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/home/runner/work/web/web/pages/about.vue")
  },
  {
    name: "artist-username___pa___default",
    path: "/artist/:username()",
    component: () => import("/home/runner/work/web/web/pages/artist/[username].vue")
  },
  {
    name: "artist-username___pa",
    path: "/pa/artist/:username()",
    component: () => import("/home/runner/work/web/web/pages/artist/[username].vue")
  },
  {
    name: "artist-username___ve",
    path: "/ve/artist/:username()",
    component: () => import("/home/runner/work/web/web/pages/artist/[username].vue")
  },
  {
    name: "artist-username___co",
    path: "/co/artist/:username()",
    component: () => import("/home/runner/work/web/web/pages/artist/[username].vue")
  },
  {
    name: "artists",
    path: "/artists",
    component: () => import("/home/runner/work/web/web/pages/artists.vue")
  },
  {
    name: "cancel-policy",
    path: "/cancel-policy",
    meta: cancel_45policyRrke4UHu1PEAmL_vfpyJmNDaIp_OXYQ_8VcCNliV85cMeta || {},
    component: () => import("/home/runner/work/web/web/pages/cancel-policy.vue")
  },
  {
    name: "cookie-policy",
    path: "/cookie-policy",
    meta: cookie_45policyQ8SkLOcfJjJY0F1efL2JYl1WznhQIzE4GDNLr83Lm3gMeta || {},
    component: () => import("/home/runner/work/web/web/pages/cookie-policy.vue")
  },
  {
    name: "delete-account___pa___default",
    path: "/delete-account",
    component: () => import("/home/runner/work/web/web/pages/delete-account.vue")
  },
  {
    name: "delete-account___pa",
    path: "/pa/delete-account",
    component: () => import("/home/runner/work/web/web/pages/delete-account.vue")
  },
  {
    name: "delete-account___ve",
    path: "/ve/delete-account",
    component: () => import("/home/runner/work/web/web/pages/delete-account.vue")
  },
  {
    name: "delete-account___co",
    path: "/co/delete-account",
    component: () => import("/home/runner/work/web/web/pages/delete-account.vue")
  },
  {
    name: "get-tickets-hash___pa___default",
    path: "/get-tickets/:hash()",
    component: () => import("/home/runner/work/web/web/pages/get-tickets/[hash].vue")
  },
  {
    name: "get-tickets-hash___pa",
    path: "/pa/get-tickets/:hash()",
    component: () => import("/home/runner/work/web/web/pages/get-tickets/[hash].vue")
  },
  {
    name: "get-tickets-hash___ve",
    path: "/ve/get-tickets/:hash()",
    component: () => import("/home/runner/work/web/web/pages/get-tickets/[hash].vue")
  },
  {
    name: "get-tickets-hash___co",
    path: "/co/get-tickets/:hash()",
    component: () => import("/home/runner/work/web/web/pages/get-tickets/[hash].vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/home/runner/work/web/web/pages/help.vue")
  },
  {
    name: "index___pa___default",
    path: "/",
    component: () => import("/home/runner/work/web/web/pages/index.vue")
  },
  {
    name: "index___pa",
    path: "/pa",
    component: () => import("/home/runner/work/web/web/pages/index.vue")
  },
  {
    name: "index___ve",
    path: "/ve",
    component: () => import("/home/runner/work/web/web/pages/index.vue")
  },
  {
    name: "index___co",
    path: "/co",
    component: () => import("/home/runner/work/web/web/pages/index.vue")
  },
  {
    name: "payment-method-method-callback___pa___default",
    path: "/payment-method/:method()/callback",
    component: () => import("/home/runner/work/web/web/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "payment-method-method-callback___pa",
    path: "/pa/payment-method/:method()/callback",
    component: () => import("/home/runner/work/web/web/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "payment-method-method-callback___ve",
    path: "/ve/payment-method/:method()/callback",
    component: () => import("/home/runner/work/web/web/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "payment-method-method-callback___co",
    path: "/co/payment-method/:method()/callback",
    component: () => import("/home/runner/work/web/web/pages/payment-method/[method]/callback.vue")
  },
  {
    name: "platform",
    path: "/platform",
    component: () => import("/home/runner/work/web/web/pages/platform.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policy_7rhbN_uxE3aF5EevBZ7sgGXdp0YOvWV93VSpd24xiIMeta || {},
    component: () => import("/home/runner/work/web/web/pages/privacy-policy.vue")
  },
  {
    name: "producer-username___pa___default",
    path: "/producer/:username()",
    component: () => import("/home/runner/work/web/web/pages/producer/[username].vue")
  },
  {
    name: "producer-username___pa",
    path: "/pa/producer/:username()",
    component: () => import("/home/runner/work/web/web/pages/producer/[username].vue")
  },
  {
    name: "producer-username___ve",
    path: "/ve/producer/:username()",
    component: () => import("/home/runner/work/web/web/pages/producer/[username].vue")
  },
  {
    name: "producer-username___co",
    path: "/co/producer/:username()",
    component: () => import("/home/runner/work/web/web/pages/producer/[username].vue")
  },
  {
    name: "producers",
    path: "/producers",
    component: () => import("/home/runner/work/web/web/pages/producers.vue")
  },
  {
    name: "sell",
    path: "/sell",
    component: () => import("/home/runner/work/web/web/pages/sell.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditionswsPqjgtoCx8PlbhBBUt9lXw_45pJjzQXrrxFso_45btronoMeta || {},
    component: () => import("/home/runner/work/web/web/pages/terms-and-conditions.vue")
  },
  {
    name: "use-conditions",
    path: "/use-conditions",
    meta: use_45conditions_45AJnN3o4et6CZncfFiemOwBdDEN95ERM4OvwB7uaDN0Meta || {},
    component: () => import("/home/runner/work/web/web/pages/use-conditions.vue")
  }
]